import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`
  return config
})

export interface MatchedCampaign {
  name: string
  enabled: boolean
}

export interface CitySearchAccount {
  _id: string
  name: string
  company_name: string
  email: string
  phone: string
  trial_period_end: string | null
  active: boolean
  library_occupation: string | null
  matched_campaigns: MatchedCampaign[]
  matched_searches: string[]
}

export function searchAccountsByCity(
  q: string,
  activeOnly: boolean
): Promise<{data: {success: boolean; query: string; count?: number; accounts: CitySearchAccount[]; message?: string}}> {
  return adminApi.get(`${API_URL}/admin/account-city-search`, {
    params: {q, activeOnly: activeOnly ? 1 : 0},
  })
}
